var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-item",class:{ selected: _vm.brand.IsSelected },attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('item-click')}}},[_c('div',{staticClass:"brand-item__info"},[_c('h3',[_vm._v(_vm._s(_vm.brand.brands))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }